import { CLUB_CMS_PATH, EM_CLUB_CMS_PATH } from './constants';
import ClubCMSRoot from './ClubCMSRoot';

export const router = [
  {
    path: CLUB_CMS_PATH,
    component: ClubCMSRoot
  },
  {
    path: EM_CLUB_CMS_PATH,
    component: ClubCMSRoot
  }
];



// WEBPACK FOOTER //
// ./src/components/ClubCMS/index.js